import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AppSettings } from "../../app/appSettings";
import { FacharztAPIService } from "../../providers/api-handler/api-handler";
import { StorageManager } from "../../providers/storage-manager/storage-manager";
import { Events } from "../eventService/events";
//import { Events } from "ionic-angular";
import moment from "moment";
import { Account } from "../../providers/content-provider/data-objects";
import { IAccountManager } from "./IAccoung-manager";
import { catchError, publishLast } from "rxjs/operators";


@Injectable()
export class AccountManagerPatient implements IAccountManager {
  DEBUG = AppSettings.DEBUG;
  TAG = "AccountManager";
  loggedIn: boolean = false;
  token: string = "";
  tokenExpire: number = 0;
  refreshObservable: any = null;
f
  constructor(
    public api: FacharztAPIService,
    public storageMnger: StorageManager,
    public events: Events
  ) {}

  isLoggedIn(): Observable<boolean> {
    if (this.DEBUG) console.log(this.TAG, "isLoggedIn");
    return Observable.create(observer => {
      if (this.loggedIn) {
        observer.next(this.loggedIn);
      } else {
        this.getAccessToken().subscribe(
          key => {
            if (key !== null) {
              this.loggedIn = true;
              observer.next(this.loggedIn);
            } else {
              this.loggedIn = false;
              observer.next(this.loggedIn);
              if (this.DEBUG)
                console.log(this.TAG, "isLoggedIn", "no access token received");
            }
          },
          error => {
            if (this.DEBUG) console.log(this.TAG, "error catched");
            this.loggedIn = false;
            observer.next(this.loggedIn);
          }
        );
      }
    });
  }

  switchPatient(data): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "switchPatient", data);

    return Observable.create(observer => {
      var keysToDelete = [];
      this.storageMnger.storage
        .forEach(function(value, key, iterationNumber) {
          if (key.indexOf("patient_") != -1) {
            keysToDelete.push(key);
          }
        })
        .then(() => {
          var promises = [];
          for (var i = keysToDelete.length - 1; i >= 0; i--) {
            promises.unshift(this.storageMnger.storage.remove(keysToDelete[i]));
          }
          Promise.all(promises).then(rdy => {
            var result = {
              expires_in: data.accessExp - this.getCurTS(),
              access_token: data.access,
              refresh_token: data.refresh
            };
            this.storageMnger.set("persistent", "last_email", data.email);
            this.storageMnger.set("persistent", "last_user_email", data.email);

            //store tokens in local storage
            this.saveTokensInStorage(result).then(rdy => {
              // this.addCurrentPatientToAccountManagement(result);
              this.loggedIn = true;

              this.events.publish("login");
              this.events.publish("refresh");

              observer.next(result);
              observer.complete();
            });
          });
        });
    });
  }

  loginPatient(data): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "loginPatient", data);

    this.storageMnger.set("persistent", "last_email", data.mail);
    this.storageMnger.set("persistent", "last_user_email", data.mail);
    if (this.DEBUG) console.log(this.TAG, "storageDATA", this.storageMnger.storage);

    return Observable.create(observer => {
      this.storageMnger.removePrivateData(false).then(rdy => {
        if(this.DEBUG)console.log("removePrivate 1", rdy);
        this.api.login(data.mail, data.pw).subscribe(
          result => {
            if(this.DEBUG)console.log("login", result);
        
            this.api.getPatient(result.access_token).subscribe(
              patient => {
                //save to storage
                //Todo braucht nicht gespeichert werden 
                //this.storageMnger.set("patient", 0, JSON.stringify(patient));

                //store tokens in local storage
                this.saveTokensInStorage(result).then(() => {
                  this.addCurrentPatientToAccountManagement(
                    result,
                    patient
                  ).then(() => {
                    this.loggedIn = true;
                    this.events.publish("login");
                    this.events.publish("refresh");
                    observer.next(result);
                    observer.complete();
                  });
                });
              },
              error => {
                return error;
              }
            );
          },
          error => {
            observer.error(error);
          }
        );
      });
    });
  }


  logoutNew(): Observable<any>{
    if (this.DEBUG) console.log(this.TAG, "logout");
    this.loggedIn = false;
    return Observable.create(observer => {
      this.getAccessToken().subscribe(
        key => {
          this.api.logout(key).subscribe(data => {
            if(this.DEBUG)console.log(this.TAG, "logout", "data from api", data);
            
            this.logoutActiveUser();
            return observer.complete();
          }), error => {
            this.logoutActiveUser();
            observer.complete();
            return observer.error(error);
          }
        },error => {
          if (this.DEBUG)
            console.log(this.TAG, "logout", "error while logging out", error);
            this.logoutActiveUser();
            observer.complete();

          return observer.error(error);
        },
      )
    })    
  }


  //Todo update logout funktion 


  logout(): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "logout");
    this.loggedIn = false;
    return Observable.create(observer => {
      // this.removePatientFromAccountManagement();
      this.getAccessToken().subscribe(
        key => {
          this.api.logout(key).subscribe(data => {
            if (this.DEBUG)
              console.log(this.TAG, "logout", "data from api", data);
            observer.complete();
          });
        },
        error => {
          if (this.DEBUG)
            console.log(this.TAG, "logout", "error while logging out", error);
          observer.complete();
        },
        () => {
          // console.log("finally");
          this.logoutActiveUser();
        }
      );
    });
    
    
    
    
/*     , catchError((e: any) =>{
      if (e.status == 401) {
        if (this.DEBUG) console.log(this.TAG, "no permission", "logging out");
        this.logoutActiveUser();
        return throwError(e);
      } else {
        return throwError(e);
      }
    }) */
    
    
    
    
 /*    .catch(e => {
      if (e.status == 401) {
        if (this.DEBUG) console.log(this.TAG, "no permission", "logging out");
        this.logoutActiveUser();
        return Observable.throw(e);
      } else {
        return Observable.throw(e);
      }
    }); */
 
  }

 /*  logoutKC(): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "logout");
    this.loggedIn = false;
    return Observable.create(observer => {
      // this.removePatientFromAccountManagement();
      this.getAccessToken().subscribe(
        key => {
          this.api.logout(key).subscribe(data => {
            if (this.DEBUG)
              console.log(this.TAG, "logout", "data from api", data);
            observer.complete();
          });
        },
        error => {
          if (this.DEBUG)
            console.log(this.TAG, "logout", "error while logging out", error);
          observer.complete();
        },
        () => {
          // console.log("finally");
          this.logoutActiveUser();
        }
      );
    }).catch(e => {
      if (e.status == 401) {
        if (this.DEBUG) console.log(this.TAG, "no permission", "logging out");
        this.logoutActiveUser();
        return Observable.throw(e);
      } else {
        return Observable.throw(e);
      }
    });
  } */

  saveTokensInStorage(tokes): Promise<any> {
    this.token = tokes.access_token;
    this.tokenExpire = this.getCurTS() + tokes.expires_in;
    return Promise.all([
      this.storageMnger.set(
        "key",
        "access",
        tokes.access_token,
        tokes.expires_in
      ),
      this.storageMnger.set("key", "refresh", tokes.refresh_token)
    ]);
  }

  logoutActiveUser(): void {
    this.removePatientFromAccountManagement();
    this.storageMnger.removePrivateData(true).then(() => {
      this.loggedIn = false;
      this.token = "";
      this.tokenExpire = 0;
      this.events.publish("logout");
    });
  }

  addCurrentPatientToAccountManagement(tokens, patient): Promise<any> {
    if (this.DEBUG)
      console.log(this.TAG, "addCurrentPatientToAccountManagement");
    return Observable.create(observer => {
      this.addPatientToAccountManagement(patient, tokens).then(promise => {
        observer.next(promise);
        observer.complete();
      });
    }).toPromise();
  }

  addPatientToAccountManagement(data, tokens): Promise<any> {
    if (this.DEBUG)
      console.log(this.TAG, "addPatientToAccountManagement", data);
    return Observable.create(observer => {
      this.getManagedAccounts().subscribe(accounts => {
        for (var i = accounts.length - 1; i >= 0; i--) {
          if (accounts[i].email == data.email) {
            accounts.splice(i, 1);
          }
        }
        let name = data.name;
        if (data.surname !== undefined) {
          name = data.name + " " + data.surname;
        }
        accounts.push(
          new Account({
            email: data.email,
            access: tokens.access_token,
            accessExp: this.getCurTS() + tokens.expires_in,
            refresh: tokens.refresh_token,
            name: name
          })
        );

        observer.next(
          this.storageMnger.storage.set(
            "AccMng_accounts",
            JSON.stringify(accounts)
          )
        );
        observer.complete();
      });
    }).toPromise();
  }

  updateTokensInAccountManagement(oldToken, tokens): Promise<any> {
    if (this.DEBUG)
      console.log(this.TAG, "updateTokensInAccountManagement", oldToken);
    return Observable.create(observer => {
      this.getManagedAccounts().subscribe(accounts => {
        for (var i = accounts.length - 1; i >= 0; i--) {
          if (
            accounts[i].refresh == oldToken ||
            accounts[i].access == oldToken
          ) {
            accounts[i].access = tokens.access_token;
            accounts[i].accessExp = this.getCurTS() + tokens.expires_in;
            accounts[i].refresh = tokens.refresh_token;
          }
        }
        observer.next(
          this.storageMnger.storage.set(
            "AccMng_accounts",
            JSON.stringify(accounts)
          )
        );
        observer.complete();
      });
    }).toPromise();
  }

  removePatientFromAccountManagement(): void {
    this.getManagedAccounts().subscribe(accounts => {
      this.storageMnger.storage.get("persistent_last_user_email").then(data => {
        if (data != null) {
          for (var i = accounts.length - 1; i >= 0; i--) {
            if (accounts[i].email == data) {
              accounts.splice(i, 1);
              this.storageMnger.storage.set(
                "AccMng_accounts",
                JSON.stringify(accounts)
              );
            }
          }
        }
      });
    });
  }

  getManagedAccounts(): Observable<Account[]> {
    if (this.DEBUG) console.log(this.TAG, "getManagedAccounts");

    return Observable.create(observer => {
      this.storageMnger.storage.get("AccMng_accounts").then(data => {
        if (data != null) {
          observer.next(
            JSON.parse(data).map((acc: any) => {
              return new Account(acc);
            })
          );
          observer.complete();
        } else {
          observer.next([]);
          observer.complete();
        }
      });
    });
  }

  getAccessToken(): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getAccessToken");
    return Observable.create(observer => {
      let now = this.getCurTS();
      if (this.token != "" && now < this.tokenExpire) {
        if (this.DEBUG)
          console.log(this.TAG, "getAccessToken", "already initialized");
        observer.next(this.token);
        observer.complete();
      } else {
        this.storageMnger
          .getExpiredFromStorage("key", "access")
          .subscribe(expired => {
            this.tokenExpire = expired.timestamp;
            if (expired.expired) {
              this.getNewAccessToken().subscribe(
                token => {
                  this.token = token;
                  observer.next(token);
                  observer.complete();
                },
                error => {
                  observer.error(error);
                  observer.complete();
                }
              );
            } else {
              return this.storageMnger
                .getFromStorage("key", "access")
                .subscribe(token => {
                  if (
                    token === null ||
                    token == "undefined" ||
                    token === undefined ||
                    token === ""
                  ) {
                    if (this.DEBUG)
                      console.log(
                        this.TAG,
                        "getAccessToken",
                        "no access token in storage"
                      );
                    //retry (corrupted data sets should be deleted by getFromStorage)
                    this.getNewAccessToken().subscribe(
                      token => {
                        observer.next(token);
                        this.token = token;
                        observer.complete();
                        // this.tokenExpire=tokes.expires_in;
                      },
                      error => {
                        observer.error(error);
                        observer.complete();
                      }
                    );
                  } else {
                    this.token = token;
                    observer.next(token);
                    observer.complete();
                  }
                });
            }
          });
      }
    });
  }

  getNewAccessToken(): Observable<any> {
    if (this.DEBUG) console.log(this.TAG, "getNewAccessToken ");
    if (this.refreshObservable === null) {
      // console.log("getNewAccessToken start");

      this.refreshObservable = Observable.create(observer => {
        this.storageMnger
          .getExpiredFromStorage("key", "refresh")
          .subscribe(expired => {
            if (expired.expired) {
              if (this.DEBUG)
                console.log(
                  this.TAG,
                  "getNewAccessToken",
                  "refresh token expired - user needs to log in with mail and pw data"
                );

              /*this.logout().subscribe(message => {
                // console.log("logout: "+message);
              });*/
              observer.error(Error("no refresh token"));
              observer.complete();
            } else {
              this.storageMnger
                .getFromStorage("key", "refresh")
                .subscribe(key => {
                  if (
                    key === null ||
                    key == "undefined" ||
                    key === undefined ||
                    key === ""
                  ) {
                    if (this.DEBUG)
                      console.log(
                        this.TAG,
                        "getNewAccessToken",
                        "no refresh token in storage - user needs to log in with mail and pw data"
                      );

                    /*this.logout().subscribe(message => {
                      // console.log("logout: "+message);
                    });*/
                    observer.error(Error("no refresh token"));
                    observer.complete();
                  } else {
                    this.api.getNewAccessToken(key).subscribe(
                      keys => {
                        if (this.DEBUG)
                          console.log(
                            this.TAG,
                            "getNewAccessToken",
                            "result data from api.getNewAccessToken()",
                            keys
                          );
                        //store data in local storage
                        this.saveTokensInStorage(keys);
                        this.updateTokensInAccountManagement(key, keys);

                        observer.next(keys.access_token);
                        observer.complete();
                      },
                      error => {
                        if (this.DEBUG)
                          console.log(
                            this.TAG,
                            "getNewAccessToken",
                            "error getting new access token",
                            error
                          );
                        observer.error(error);
                      }
                    );
                  }
                });
            }
          });
      });

      
      return this.refreshObservable;
    } else {
      return this.refreshObservable;
    }
  }

  //retunr current timestamp in seconds
  getCurTS(): number {
    return moment().unix();
  }

  refreshTokens(access, expire, refresh) {
    if (this.DEBUG)
      console.log(this.TAG, "refreshTokens ", access, expire, refresh);
    return Observable.create(observer => {
      this.storageMnger.isExpired(expire).subscribe(isExpired => {
        if (this.DEBUG)
          console.log(this.TAG, "refreshTokens expired ", isExpired);
        if (isExpired.expire) {
          this.api.getNewAccessToken(refresh).subscribe(
            keys => {
              if (this.DEBUG)
                console.log(this.TAG, "refreshTokens new tokens ", keys);
              // if(this.DEBUG) console.log(this.TAG, 'getNewAccessToken', 'result data from api.getNewAccessToken()', keys);
              //store data in local storage
              // this.saveTokensInStorage(keys);
              if (access == this.token) {
                this.saveTokensInStorage(keys).then();
              }
              this.updateTokensInAccountManagement(access, keys);
              keys.expires_in += this.getCurTS();
              observer.next(keys);
              observer.complete();
            },
            error => {
              // if(this.DEBUG) console.log(this.TAG, 'getNewAccessToken', 'error getting new access token', error);
              observer.error(error);
              observer.complete();
            }
          );
        } else {
          observer.next({
            refresh_token: refresh,
            access_token: access,
            expires_in: expire
          });
          observer.complete();
        }
      });
    });
  }

  //implementing interface
  switchAccount(data: any): Observable<any> {
    return this.switchPatient(data);
  }
  login(data: any): Observable<any> {
    return this.loginPatient(data);
  }
  addCurrentToAccountManagement(tokens: any, Doctor: any): Promise<any> {
    return this.addCurrentPatientToAccountManagement(tokens, Doctor);
  }
  addToAccountManagement(data: any, tokens: any): Promise<any> {
    return this.addPatientToAccountManagement(data, tokens);
  }
  removeFromAccountManagement(): void {
    return this.removePatientFromAccountManagement();
  }

}
